// src/views/AdminView.js
import React, { useState, useEffect } from 'react';
import { api } from '../api/db';

export default function AdminView({ themeClasses }) {
  const [users, setUsers] = useState([]);
  
  useEffect(() => { 
    api.getUsers().then(setUsers).catch(e => console.warn(e)); 
  }, []);
  
  const handleDelete = (id) => { 
    api.deleteUser(id); 
    setUsers(users.filter(u => u.id !== id)); 
  };

  return (
    <div className="max-w-5xl mx-auto space-y-8">
       <div>
         <h1 className={`text-3xl font-black text-red-500 mb-2`}>Terminal Administration</h1>
         <p className={`text-sm ${themeClasses.textMuted} font-medium`}>Manage user access and global VPS parameters.</p>
       </div>
       <div className={`${themeClasses.bgCard} rounded-3xl border ${themeClasses.border} shadow-xl overflow-hidden`}>
          <table className="w-full text-left text-sm">
             <thead className={`${themeClasses.input} border-b ${themeClasses.border}`}>
               <tr>
                 <th className={`p-4 font-black uppercase text-[10px] tracking-widest ${themeClasses.textMuted}`}>ID</th>
                 <th className={`p-4 font-black uppercase text-[10px] tracking-widest ${themeClasses.textMuted}`}>Username</th>
                 <th className={`p-4 font-black uppercase text-[10px] tracking-widest ${themeClasses.textMuted}`}>Role Access</th>
                 <th className={`p-4 font-black uppercase text-[10px] tracking-widest ${themeClasses.textMuted} text-right`}>Actions</th>
               </tr>
             </thead>
             <tbody>
               {users.map(u => (
                 <tr key={u.id} className={`border-b ${themeClasses.border} last:border-0`}>
                   <td className={`p-4 font-mono text-xs ${themeClasses.textMuted}`}>{u.id}</td>
                   <td className={`p-4 font-bold ${themeClasses.textHead}`}>{u.username}</td>
                   <td className="p-4">
                     <span className={`px-2 py-1 rounded text-[10px] font-black uppercase tracking-widest ${u.role === 'admin' ? 'bg-red-500/10 text-red-500' : 'bg-indigo-500/10 text-indigo-500'}`}>
                       {u.role}
                     </span>
                   </td>
                   <td className="p-4 text-right">
                     {u.role !== 'admin' && (
                       <button onClick={() => handleDelete(u.id)} className="text-red-500 hover:text-red-600 text-[10px] font-bold uppercase tracking-widest">
                         Revoke Access
                       </button>
                     )}
                   </td>
                 </tr>
               ))}
             </tbody>
          </table>
       </div>
    </div>
  );
}